import type { ProjectType } from '@atlassian/jira-common-constants/src/index.tsx';
import type { ProjectSettingsPage } from '@atlassian/jira-forge-ui-types/src/common/types/extension.tsx';
import { parseExtensionId } from '@atlassian/jira-forge-ui-utils-internal/src/utils/parse-extension-id/index.tsx';

export const getItemHref = (
	extension: ProjectSettingsPage,
	projectType: ProjectType,
	projectKey: string,
) => {
	const { appId, envId } = parseExtensionId(extension.id);
	return `/jira/${projectType}/projects/${projectKey}/settings/apps/${appId}/${envId}`;
};
